// ===================================================================
// KAIXO - useLeaderboard hook
// ===================================================================

import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export function useLeaderboard({ scope = 'global', window = 'all', country, language, interest } = {}) {
    const [leaders, setLeaders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams();
            params.append('scope', scope);
            params.append('window', window);
            if (country)  params.append('country', country);
            if (language) params.append('language', language);
            if (interest) params.append('interest', interest);
            const { data } = await api.get(`/latidoDorado/leaderboard?${params.toString()}`);
            setLeaders(data.leaders || []);
        } catch (e) {
            setError(e.message);
            setLeaders([]);
        } finally {
            setLoading(false);
        }
    }, [scope, window, country, language, interest]);

    useEffect(() => { load(); }, [load]);

    return { leaders, loading, error, reload: load };
}

export default useLeaderboard;
